<script>
import appConfig from "@/app.config"
import Layout from "@/views/layouts/main"
import PageHeader from "@/components/page-header"
import atendimentoController from "@/controller/AtendimentoController"
import ValidationRecurrenceList from "./validation-recurrence-list.vue"
import Multiselect from "vue-multiselect"
import {
  filterActiveProfessionals,
  isProfessionalActive,
  mapProfessionalOption,
  professionalFilterLabel,
} from "@/helpers/professionalStatus"
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Swal from "sweetalert2"
import AccountPayable from "@/controller/AccountsPayable"

export default {
  name: 'ValidationRecurrence',
  page: {
    title: "Validação dar Evoluções",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { Layout, PageHeader, ValidationRecurrenceList, Multiselect, FormWizard, TabContent },
  data() {
    return {
      recurrence: null,
      accountPayable: {},
      listProfessionals: [],
      listAgreements: [],
      listAgreementsPluck: [],
      listProfessionalsPluck: [],
      listPatientsOptions: [],
      contas: [],
      pagamentos: [],
      planoContas: [],
      isShowModalFormWizard: false,
      isLoadingValidations: false,
      params: {
        professional: null,
        patient: null,
        agreements: [],
        date_ini: null,
        date_end: null,
        is_billed: 'all',
        is_cancelled: 'all',
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      listAtendimentos: [],
      selectedIds: [],
      selectedStats: {
        cancelled: 0,
        notCancelled: 0,
        total: 0,
      },
      errors: {},
      multiselectPatientKey: 0,
    }
  },
  watch: {
    'params.professional': {
      handler(newVal, oldVal) {
        if (newVal?.id !== oldVal?.id) {
          this.params.patient = null
          this.multiselectPatientKey += 1
          this.loadPatients()
        }
      },
    },
  },
  computed: {
    // Estatísticas de faturamento dos itens selecionados
    selectedBillingStats() {
      if (!this.selectedIds || this.selectedIds.length === 0 || !this.listAtendimentos || this.listAtendimentos.length === 0) {
        return {
          billed: 0,
          notBilled: 0,
          total: 0
        }
      }
      
      // Obtém os itens selecionados
      const selectedItems = this.selectedIds
        .map(id => this.findItemByAnyId(id))
        .filter(Boolean)
      
      if (selectedItems.length === 0) {
        return {
          billed: 0,
          notBilled: 0,
          total: 0
        }
      }
      
      const billed = selectedItems.filter(item => item.is_billed === true || item.is_billed === 1).length
      const notBilled = selectedItems.filter(item => !item.is_billed || item.is_billed === false || item.is_billed === 0).length
      
      return {
        billed,
        notBilled,
        total: selectedItems.length
      }
    }
  },
  created() {
    this.currentUser = JSON.parse(localStorage.getItem("user"))
    this.currentEmpresa = JSON.parse(localStorage.getItem("currentEmpresa"))
    this.atendimentoController = new atendimentoController(this.currentUser, this.currentEmpresa)
    this.AccountPayable = new AccountPayable(this.currentUser, this.currentEmpresa)
    this.getTable().then(() => {
      this.contas     = this.planoContas.filter(conta => conta.conta_pgto === 1)
      this.pagamentos = this.planoContas.filter(conta => conta.conta_pgto === 0 && conta.grupo_pgto !== null)
    })
  },
  mounted() {
    this.loadMonth()
  },
  methods: {
    isProfessionalActive,
    professionalFilterLabel,
    // Filtro de hoje
    loadToday() {
      const today = new Date()
      this.params.date_ini = this.formatDateYmd(today)
      this.params.date_end = this.formatDateYmd(today)
      this.currentPage = 1
      this.onFilters(this.params)
    },
    // Semana em curso: segunda-feira até sábado, terminando no dia atual (ou sábado se hoje for domingo)
    loadWeek() {
      const today = new Date()
      const day = today.getDay() // 0=domingo, 1=segunda, ... 6=sábado
      const offsetFromMonday = (day + 6) % 7 // segunda=0, ... domingo=6
      const monday = new Date(today)
      monday.setHours(0, 0, 0, 0)
      monday.setDate(today.getDate() - offsetFromMonday)
      const saturday = new Date(monday)
      saturday.setDate(monday.getDate() + 5)
      const endDate = (day === 0) ? saturday : (today < saturday ? today : saturday)
      this.params.date_ini = this.formatDateYmd(monday)
      this.params.date_end = this.formatDateYmd(endDate)
      this.currentPage = 1
      this.onFilters(this.params)
    },
    // Filtro mês atual
    loadMonth() {
      const now = new Date()
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      this.params.date_ini = this.formatDateYmd(firstDay)
      this.params.date_end = this.formatDateYmd(lastDay)
      this.currentPage = 1
      this.onFilters(this.params)
    },
    // Formata Date para YYYY-MM-DD (sem efeitos de timezone de ISO)
    formatDateYmd(dateObj) {
      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0')
      const day = String(dateObj.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // Atualiza seleção vinda do componente de lista
    onChangeSelected(newSelected) {
      this.selectedIds = Array.isArray(newSelected) ? newSelected : []
      console.log('selectedBillingStats.billed', this.selectedBillingStats.billed)
      console.log('selectedBillingStats.notBilled', this.selectedBillingStats.notBilled)
    },
    // Atualiza estatísticas de seleção
    onChangeSelectedStats(stats) {
      this.selectedStats = stats || { cancelled: 0, notCancelled: 0, total: 0 }
    },
    // Obtém item por id (aceita id ou agenda_id)
    findItemByAnyId(anyId) {
      return this.listAtendimentos.find(it => (it.id === anyId) || (it.agenda_id === anyId))
    },
    getSingleSelectedProfessional() {
      const selected = this.params.professional
      const professionals = Array.isArray(selected)
        ? selected
        : (selected ? [selected] : [])

      if (professionals.length !== 1 || !professionals[0]?.id) {
        return null
      }

      return professionals[0]
    },
    requireSingleSelectedProfessional() {
      const selected = this.params.professional
      const professionals = Array.isArray(selected)
        ? selected
        : (selected ? [selected] : [])

      if (professionals.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Profissional obrigatório', text: 'Selecione um profissional para faturar.' })
        return null
      }

      if (professionals.length !== 1 || !professionals[0]?.id) {
        Swal.fire({ icon: 'warning', title: 'Selecione apenas um profissional', text: 'O faturamento deve ser associado a exatamente um profissional.' })
        return null
      }

      return professionals[0]
    },
    // Valida e executa faturamento
    async billSelected() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Seleção vazia', text: 'Selecione ao menos um registro.' })
        return
      }
      const professional = this.requireSingleSelectedProfessional()
      if (!professional) return
      
      const selectedItems = this.selectedIds.map(id => this.findItemByAnyId(id)).filter(Boolean)
      const alreadyBilled = selectedItems.filter(it => it && it.is_billed)

      if (alreadyBilled.length > 0) {
        Swal.fire({ icon: 'warning', title: 'Itens já faturados', text: 'Remova da seleção os itens já faturados antes de continuar.' })
        return
      }

      try {
        Swal.fire({ title: 'Aguarde...', text: 'Faturando registros...', allowOutsideClick: false, didOpen: () => Swal.showLoading() })        
        // O controller já limpa o valor antes de enviar
        const result = await this.atendimentoController.markBilled(this.selectedIds, {
          ...this.accountPayable,
          professional_id: professional.id,
        })

        Swal.close()
        // Limpa os dados do formulário
        this.accountPayable = {}
        this.selectedIds = []
        // Fecha o modal antes de mostrar a mensagem de sucesso
        this.isShowModalFormWizard = false

        if (this.$refs.modalFormWizard) {
          this.$refs.modalFormWizard.hide()
        }

        this.onHideModalFormWizard()
        Swal.fire({ icon: 'success', title: 'Faturamento concluído', text: `${result.updated || 0} registro(s) atualizado(s).` })

        await this.onFilters(this.params)
      } catch (error) {
        console.log('error', error)
        Swal.close()
        const errorMessage = error.message || error.response?.data?.error || String(error)
        Swal.fire({ icon: 'error', title: 'Erro ao faturar', text: errorMessage })
        // Em caso de erro, não fecha o modal para o usuário poder corrigir
      }
    },
    // Valida e executa cancelamento de faturamento
    async unbillSelected() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Seleção vazia', text: 'Selecione ao menos uma Evolução.' })
        return
      }
      const selectedItems = this.selectedIds.map(id => this.findItemByAnyId(id)).filter(Boolean)
      const notBilled = selectedItems.filter(it => it && !it.is_billed)
      if (notBilled.length > 0) {
        Swal.fire({ icon: 'warning', title: 'Itens não faturados', text: 'Remova da seleção os itens não faturados antes de cancelar.' })
        return
      }
      const { isConfirmed } = await Swal.fire({
        title: 'Cancelar faturamento?',
        text: `Você deseja cancelar o faturamento de ${this.selectedIds.length} evolução(ões)?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, cancelar',
        cancelButtonText: 'Não'
      })
      if (!isConfirmed) return
      try {
        Swal.fire({ title: 'Aguarde...', text: 'Cancelando faturamento...', allowOutsideClick: false, didOpen: () => Swal.showLoading() })
        const result = await this.atendimentoController.unmarkBilled(this.selectedIds)
        Swal.close()
        Swal.fire({ icon: 'success', title: 'Cancelamento concluído', text: `${result.updated || 0} registro(s) atualizado(s).` })
        this.selectedIds = []
        await this.onFilters(this.params)
      } catch (error) {
        Swal.close()
        Swal.fire({ icon: 'error', title: 'Erro ao cancelar faturamento', text: String(error) })
      }
    },
    // Valida e executa cancelamento de evolução
    async cancelSelected() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Seleção vazia', text: 'Selecione ao menos uma evolução para cancelar.' })
        return
      }
      
      // Verifica se há algum item já cancelado
      const selectedItems = this.selectedIds.map(id => this.findItemByAnyId(id)).filter(Boolean)
      const alreadyCancelled = selectedItems.filter(it => it && it.is_cancelled)
      
      if (alreadyCancelled.length > 0) {
        Swal.fire({ icon: 'warning', title: 'Itens já cancelados', text: 'Remova da seleção os itens já cancelados antes de continuar.' })
        return
      }

      const { isConfirmed } = await Swal.fire({
        title: 'Cancelar evolução?',
        text: `Você deseja cancelar ${this.selectedIds.length} evolução(ões)? Esta ação não pode ser desfeita.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, cancelar',
        cancelButtonText: 'Não',
        confirmButtonColor: '#f0ad4e'
      })
      
      if (!isConfirmed) return
      
      try {
        Swal.fire({ title: 'Aguarde...', text: 'Cancelando evolução(ões)...', allowOutsideClick: false, didOpen: () => Swal.showLoading() })
        const result = await this.atendimentoController.cancelRecurrences(this.selectedIds)
        Swal.close()
        Swal.fire({ icon: 'success', title: 'Cancelamento concluído', text: `${result.updated || 0} evolução(ões) cancelada(s).` })
        this.selectedIds = []
        await this.onFilters(this.params)
      } catch (error) {
        Swal.close()
        const errorMessage = error.response?.data?.error || String(error)
        Swal.fire({ icon: 'error', title: 'Erro ao cancelar evolução', text: errorMessage })
      }
    },
    // Valida e executa reativação de evolução
    async reactivateSelected() {
      if (!this.selectedIds || this.selectedIds.length === 0) {
        Swal.fire({ icon: 'warning', title: 'Seleção vazia', text: 'Selecione ao menos uma evolução para reativar.' })
        return
      }
      
      // Verifica se há algum item não cancelado
      const selectedItems = this.selectedIds.map(id => this.findItemByAnyId(id)).filter(Boolean)
      const notCancelled = selectedItems.filter(it => it && !it.is_cancelled)
      
      if (notCancelled.length > 0) {
        Swal.fire({ icon: 'warning', title: 'Itens não cancelados', text: 'Remova da seleção os itens não cancelados antes de continuar.' })
        return
      }

      const { isConfirmed } = await Swal.fire({
        title: 'Reativar evolução?',
        text: `Você deseja reativar ${this.selectedIds.length} evolução(ões) cancelada(s)?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim, reativar',
        cancelButtonText: 'Não',
        confirmButtonColor: '#17a2b8'
      })
      
      if (!isConfirmed) return
      
      try {
        Swal.fire({ title: 'Aguarde...', text: 'Reativando evolução(ões)...', allowOutsideClick: false, didOpen: () => Swal.showLoading() })
        const result = await this.atendimentoController.reactivateRecurrences(this.selectedIds)
        Swal.close()
        Swal.fire({ icon: 'success', title: 'Reativação concluída', text: `${result.updated || 0} evolução(ões) reativada(s).` })
        this.selectedIds = []
        await this.onFilters(this.params)
      } catch (error) {
        Swal.close()
        const errorMessage = error.response?.data?.error || String(error)
        Swal.fire({ icon: 'error', title: 'Erro ao reativar evolução', text: errorMessage })
      }
    },
    async loadPatients() {
      if (!this.currentEmpresa?.id) return
      try {
        const professionalId = this.params.professional?.id || null
        const tableParams = { empresa_id: this.currentEmpresa.id }
        if (professionalId) tableParams.professional_id = professionalId
        const res = await this.atendimentoController.doGetTable(tableParams)
        const patients = res.data?.pacients || []
        this.listPatientsOptions = patients.map((p) => {
          const id = p.id
          const name = p.nome || ''
          return { id, name, label: `${String(id)} - ${name}` }
        })
      } catch {
        this.listPatientsOptions = []
      }
    },
    async getTable() {
      Swal.fire({
        title: 'Aguarde...',
        text: 'Estamos processando sua solicitação.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      try {
        const response = await this.atendimentoController.doGetTable(this.params)
        this.listAgreements = response.data.agreements;
        // Carrega no listAgreementsPluck o objeto agreements com um value Convênios
        // e o segundo value um array de objetos com o id e name do agreement
        this.listAgreementsPluck = [{
          grupo: 'Todos os Convênios',
          convenios: response.data.agreements.map((agreement) => ({
            id: agreement.id,
            name: agreement.name,
          }))
        }];
        this.listProfessionals = response.data.professionals
        this.listProfessionalsPluck = filterActiveProfessionals(response.data.professionals).map((professional) =>
          mapProfessionalOption(professional)
        )
        await this.loadPatients()
      } catch (error) {
        // noop
      }

      try {
        const result = await this.AccountPayable.getAccountsPayable()

        if (result.success) {
          this.contas = result.data.contasPagar
          this.pagamentos = result.data.planoContas
          this.planoContas = result.data.planoContas;
          setTimeout(() => {
            Swal.close();
          }, 2000);
        }
      } catch (error) {
        // noop
      }
    },
    async onFilters(params) {
      this.isLoadingValidations = true
      try {
        const callParams = { ...params }

        if (!callParams.professional && !callParams.date_ini && !callParams.date_end && !callParams.patient) {
          callParams.sample = true
        }

        callParams.debug = true
        callParams.page = this.currentPage
        callParams.per_page = this.perPage

        let response = await this.atendimentoController.getValidations(callParams)
        this.listAtendimentos = response.data || []

        if (response.meta) {
          this.totalRows = response.meta.total || 0
          this.perPage = response.meta.per_page || this.perPage
          this.currentPage = response.meta.current_page || this.currentPage
        }

        // Se não retornou nada e não estávamos em modo sample, tenta sample para diagnosticar
        if ((!this.listAtendimentos || this.listAtendimentos.length === 0) && !callParams.sample) {
          const sampleParams = { ...callParams, sample: true }
          response = await this.atendimentoController.getValidations(sampleParams)

          if (response.data && response.data.length) {
            this.listAtendimentos = response.data
            this.$bvToast.toast('Mostrando amostra por não haver resultados nos filtros.', {
              title: 'Sem resultados nos filtros',
              variant: 'warning',
              solid: true,
              toaster: 'b-toaster-bottom-right'
            })
          }
        }
      } catch (error) {
        this.$bvToast.toast(error, {
          title: 'Erro ao aplicar filtros',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-right'
        })
      } finally {
        this.isLoadingValidations = false
      }
    },
    filterContaDebito(descricao) {
      let contasDespesas = this.planoContas.filter(conta => conta.conta_pgto === 1)

      if (!descricao) {
        this.contas = contasDespesas
      } else {
        this.contas = contasDespesas.filter(conta => conta.descricao.toLowerCase().includes(descricao.toLowerCase()))
      }
    },
    filterContaCredito(descricao) {
      let contasPagamentos = this.planoContas.filter(conta => conta.conta_pgto === 0 && conta.grupo_pgto !== null)

      if (!descricao) {
        this.pagamentos = contasPagamentos
      } else {
        this.pagamentos = contasPagamentos.filter(conta => conta.descricao.toLowerCase().includes(descricao.toLowerCase()))
      }
    },
    async onChangePage(page) {
      this.currentPage = page
      await this.onFilters(this.params)
    },
    async onChangePerPage(perPage) {
      this.perPage = perPage
      this.currentPage = 1
      await this.onFilters(this.params)
    },
    async onBillSelected(ids) {
      if (!ids || !ids.length) {
        Swal.fire({ icon: 'warning', title: 'Seleção vazia', text: 'Selecione ao menos um registro.' })
        return
      }
      const professional = this.requireSingleSelectedProfessional()
      if (!professional) return

      try {
        Swal.fire({ title: 'Aguarde...', text: 'Faturando registros...', allowOutsideClick: false, didOpen: () => Swal.showLoading() })
        
        // O controller já limpa o valor antes de enviar
        const result = await this.atendimentoController.markBilled(ids, {
          ...this.accountPayable,
          professional_id: professional.id,
        })
        Swal.close()
        Swal.fire({ icon: 'success', title: 'Faturamento concluído', text: `${result.updated || 0} registro(s) atualizado(s).` })
        await this.onFilters(this.params)
      } catch (error) {
        Swal.close()
        const errorMessage = error.message || error.response?.data?.error || String(error)
        Swal.fire({ icon: 'error', title: 'Erro ao faturar', text: errorMessage })
      }
    },
    async onUnbillSelected(ids) {
      if (!ids || !ids.length) {
        Swal.fire({ icon: 'warning', title: 'Seleção vazia', text: 'Selecione ao menos uma Evolução.' })
        return
      }
      const { isConfirmed } = await Swal.fire({
        title: 'Cancelar faturamento?',
        text: `Você deseja cancelar o faturamento de ${ids.length} evolução(ões)?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, cancelar',
        cancelButtonText: 'Não'
      })
      if (!isConfirmed) return
      try {
        Swal.fire({ title: 'Aguarde...', text: 'Cancelando faturamento...', allowOutsideClick: false, didOpen: () => Swal.showLoading() })
        const result = await this.atendimentoController.unmarkBilled(ids)
        Swal.close()
        Swal.fire({ icon: 'success', title: 'Cancelamento concluído', text: `${result.updated || 0} registro(s) atualizado(s).` })
        await this.onFilters(this.params)
      } catch (error) {
        Swal.close()
        Swal.fire({ icon: 'error', title: 'Erro ao cancelar faturamento', text: String(error) })
      }
    },
    onShowModalFormWizard() {
      if (!this.requireSingleSelectedProfessional()) return

      this.setDeafultContaPagar()
      this.isShowModalFormWizard = true
      this.$refs.modalFormWizard.show()
    },
    onHideModalFormWizard() {
      this.isShowModalFormWizard = false
      this.accountPayable = {}
      if (this.$refs.modalFormWizard) {
        this.$refs.modalFormWizard.hide()
      }
    },
    validateStep1() {
      this.errors = {}

      if (!this.accountPayable.data_vencimento) {
        this.errors.vencimento = 'Data de vencimento é obrigatória'
        this.$refs.vencimento.focus()
      }

      if (!this.accountPayable.numero_documento) {
        this.errors.numeroDocumento = 'Documento é obrigatório'
        this.$refs.numeroDocumento.focus()
      }

      if (!this.accountPayable.valorPagar) {
        this.errors.valorPagar = 'Valor é obrigatório'
        this.$refs.valorPagar.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    validateStep2() {
      this.errors = {}

      if (!this.accountPayable.conta_credito_id) {
        this.errors.conta_credito_id = 'Conta Contábil é obrigatória'
        this.$refs.conta_credito_id.focus()
      }

      return Object.keys(this.errors).length === 0
    },
    beforeTabChange(oldIndex) {
      return this.validateCurrentStep(oldIndex)
    },
    validateCurrentStep(stepIndex) {
      switch (stepIndex) {
        case 0:
          return this.validateStep1()
      }
    },
    setDeafultContaPagar() {
      this.accountPayable = {}
      const professional = this.getSingleSelectedProfessional()
      if (!professional) return

      const professionalId = professional.id
      const professionalName = professional.name || professional.label || 'Profissional'

      const today = new Date()
      const baseEnd = this.params.date_end ? new Date(this.params.date_end) : today
      const dueDate = new Date(baseEnd.getFullYear(), baseEnd.getMonth() + 1, 0) // último dia do mês

      const nowDay = String(today.getDate()).padStart(2, '0')
      const nowMonth = String(today.getMonth() + 1).padStart(2, '0')
      const nowYear = String(today.getFullYear())

      const selectedItems = (this.selectedIds || []).map(id => this.findItemByAnyId(id)).filter(Boolean)
      const totalTransfer = selectedItems.reduce((acc, it) => acc + (Number(it && it.transfer_amount) || 0), 0)

      this.accountPayable.data_vencimento  = this.formatDateYmd(dueDate)
      // data atual
      this.accountPayable.data_emissao     = this.formatDateYmd(new Date())
      this.accountPayable.numero_documento = `${professionalId}-${nowYear}${nowMonth}${nowDay}`
      this.accountPayable.valorPagar = this.formatterFloatBR(totalTransfer, 2)
      this.accountPayable.professional_id = professionalId
      this.accountPayable.descricao = `${professionalName} - ${this.formatDateBR(this.params.date_ini) || ''} a ${this.formatDateBR(this.params.date_end || '')}`
    },
    setConta(conta_debito) {
      if (conta_debito === this.accountPayable.conta_debito) {
        this.accountPayable.conta_debito_id = null
        this.accountPayable.conta_debito = null
        return
      }

      this.accountPayable.conta_debito_id = conta_debito.id
      this.accountPayable.conta_debito = conta_debito
      this.$refs.wizardContaPagar.nextTab()
    },
    setPagamento(conta_credito) {
      if (conta_credito === this.accountPayable.conta_credito) {
        this.accountPayable.conta_credito_id = null
        this.accountPayable.conta_credito = null
        return
      }

      this.accountPayable.conta_credito_id = conta_credito.id
      this.accountPayable.conta_credito = conta_credito
      this.$refs.wizardContaPagar.nextTab()
    },
  },
}
</script>

<template>
    <layout>
        <page-header title="Validação das Evoluções e Faturamento dos Profissionais" />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body pb-0">
                        <div class="row">
                            <div class="col-12 text-md-left">
                                <b-button
                                  v-b-toggle="'collapse-filtrers'"
                                  variant="primary"
                                  class="mb-3 ml-3 mt-3"
                                >
                                  <i class="fas fa-filter"></i> Filtros
                                </b-button>
                                <b-button
                                  variant="primary"
                                  class="mb-3 ml-3 mt-3"
                                  @click="loadMonth"
                                >
                                  <i class="fas fa-calendar-alt"></i> Mês atual
                                </b-button>
                                <b-button
                                  variant="primary"
                                  class="mb-3 ml-3 mt-3"
                                  @click="loadWeek"
                                >
                                  <i class="fas fa-calendar-alt"></i> Semana atual
                                </b-button>
                                <b-button
                                  variant="primary"
                                  class="mb-3 ml-3 mt-3"
                                  @click="loadToday"
                                >
                                  <i class="fas fa-calendar-alt"></i> Hoje
                                </b-button>
                            </div>
                            <div class="col-12">
                                <b-collapse id="collapse-filtrers" class="mt-1" visible>
                                    <b-card>
                                        <div class="row">
                                          <div class="col-md-4">
                                              <b-form-group label="Profissional">
                                                  <Multiselect
                                                    v-model="params.professional"
                                                    :options="listProfessionalsPluck"
                                                    label="name"
                                                    track-by="id"
                                                    :multiple="false"
                                                    :taggable="true"
                                                    :close-on-select="true"
                                                  >
                                                    <template #option="{ option }">
                                                      <span :class="{ 'professional-inactive': !isProfessionalActive(option) }">
                                                        {{ option.label || professionalFilterLabel(option) }}
                                                      </span>
                                                    </template>
                                                    <template #singleLabel="{ option }">
                                                      <span :class="{ 'professional-inactive': !isProfessionalActive(option) }">
                                                        {{ option.label || professionalFilterLabel(option) }}
                                                      </span>
                                                    </template>
                                                  </Multiselect>
                                              </b-form-group>
                                          </div>
                                          <div class="col-md-4">
                                              <b-form-group label="Paciente">
                                                  <Multiselect
                                                    :key="'patient-' + multiselectPatientKey"
                                                    v-model="params.patient"
                                                    :options="listPatientsOptions"
                                                    placeholder="Pesquisar por ID ou nome"
                                                    label="label"
                                                    track-by="id"
                                                    :multiple="false"
                                                    :allow-empty="true"
                                                    select-label="Pressione ENTER para selecionar"
                                                    deselect-label="Pressione ENTER para remover"
                                                    selected-label="Pressione ENTER para selecionar"
                                                  >
                                                    <template #option="props">
                                                      {{ props.option.id }} - {{ props.option.name }}
                                                    </template>
                                                    <template #singleLabel="{ option }">
                                                      <span v-if="option">{{ option.id }} - {{ option.name }}</span>
                                                    </template>
                                                  </Multiselect>
                                                  <small v-if="params.professional && listPatientsOptions.length === 0" class="text-muted">
                                                    Nenhum paciente vinculado a este profissional.
                                                  </small>
                                                  <small v-else-if="params.professional" class="text-muted">
                                                    Apenas pacientes vinculados ao profissional selecionado.
                                                  </small>
                                              </b-form-group>
                                          </div>
                                          <div class="col-md-4">
                                              <b-form-group label="Convênios">
                                                  <Multiselect
                                                    v-model="params.agreements"
                                                    :options="listAgreementsPluck"
                                                    label="name"
                                                    track-by="id"
                                                    :multiple="true"
                                                    :taggable="true"
                                                    :close-on-select="true"
                                                    group-label="grupo"
                                                    group-values="convenios"
                                                    :group-select="true"
                                                  />
                                              </b-form-group>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-2">
                                              <b-form-group label="Data inicial">
                                                  <b-form-input type="date" v-model="params.date_ini" />
                                              </b-form-group>
                                          </div>
                                          <div class="col-md-2">
                                              <b-form-group label="Data final">
                                                  <b-form-input type="date" v-model="params.date_end" />
                                              </b-form-group>
                                          </div>
                                          <div class="col-md-4">
                                              <b-form-group label="Faturamento">
                                                  <b-form-radio-group
                                                    v-model="params.is_billed"
                                                    :options="[
                                                      { value: 'all', text: 'Todos' },
                                                      { value: 'true', text: 'Faturado' },
                                                      { value: 'false', text: 'Não faturado' },
                                                    ]"
                                                  />
                                              </b-form-group>
                                          </div>
                                          <div class="col-md-4">
                                              <b-form-group label="Cancelamento">
                                                  <b-form-radio-group
                                                    v-model="params.is_cancelled"
                                                    :options="[
                                                      { value: 'all', text: 'Todos' },
                                                      { value: 'false', text: 'Não cancelado' },
                                                      { value: 'true', text: 'Cancelado' },
                                                    ]"
                                                  />
                                              </b-form-group>
                                          </div>
                                          <div class="col-md-4 d-flex justify-content-start align-items-center">
                                            <span class="text-danger blockquote font-size-16 ml-2">Selecione o Período e o Profissional antes de Faturar. O filtro Paciente é opicional</span>
                                          </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <b-button variant="primary" @click="onFilters(params)">
                                                  <i class="fas fa-database"></i> Aplicar filtros
                                                </b-button>
                                            </div>
                                        </div>
                                    </b-card>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                    <div class="px-3 pt-2">
                      <!-- Estatísticas dos selecionados -->
                      <div class="d-flex align-items-center mb-2" v-if="selectedIds && selectedIds.length">
                        <span class="mr-3">
                          <strong>{{ selectedIds.length }}</strong> registro(s) selecionado(s)
                        </span>
                        <b-badge variant="success" class="mr-2">
                          Faturados: {{ selectedBillingStats.billed }}
                        </b-badge>
                        <b-badge variant="warning" class="mr-2">
                          Não faturados: {{ selectedBillingStats.notBilled }}
                        </b-badge>
                        <b-badge variant="danger" class="mr-2">
                          Cancelados: {{ selectedStats.cancelled }}
                        </b-badge>
                        <b-badge variant="info">
                          Não cancelados: {{ selectedStats.notCancelled }}
                        </b-badge>
                      </div>
                      <b-button
                        v-if="selectedBillingStats.notBilled > 0 && selectedBillingStats.billed === 0"
                       size="md" variant="success" class="mr-2" @click="onShowModalFormWizard">
                        <i class="mdi mdi-format-list-checks"></i>
                        Faturar
                      </b-button>
                      <b-button
                        v-if="selectedBillingStats.billed > 0 && selectedBillingStats.notBilled === 0"
                       size="md" variant="danger" class="mr-2" @click="unbillSelected">
                        <i class="mdi mdi-playlist-remove"></i>
                        Cancelar faturamento
                      </b-button>
                      <b-button 
                        v-if="selectedStats.cancelled === 0"
                        size="md" 
                        variant="warning" 
                        class="mr-2"
                        @click="cancelSelected"
                      >
                        <i class="mdi mdi-cancel"></i>
                        Cancelar evolução
                      </b-button>
                      <b-button 
                        v-if="selectedStats.notCancelled === 0 && selectedStats.cancelled > 0"
                        size="md" 
                        variant="info" 
                        @click="reactivateSelected"
                      >
                        <i class="mdi mdi-restore"></i>
                        Reativar evolução
                      </b-button>
                    </div>
                    <div v-if="isLoadingValidations" class="d-flex justify-content-center align-items-center my-4">
                      <b-spinner variant="primary" label="Carregando validações..."></b-spinner>
                    </div>
                    <ValidationRecurrenceList
                      v-else
                      :listAtendimentos="listAtendimentos"
                      :perPage="perPage"
                      :currentPage="currentPage"
                      :totalRows="totalRows"
                      @change-selected="onChangeSelected"
                      @change-selected-stats="onChangeSelectedStats"
                      @change-page="onChangePage"
                      @change-per-page="onChangePerPage"
                    />
                </div>
            </div>
        </div>
        <b-modal ref="modalFormWizard" 
          title="Faturamento" 
          hide-footer
          size="lg"
          :visible="isShowModalFormWizard"
          @hide="onHideModalFormWizard"
        >
          <form-wizard
            ref="wizardContaPagar"
            next-button-text="Avançar"
            finish-button-text="Gravar"
            back-button-text="Voltar"
            @on-complete="billSelected"
          >
            <tab-content icon="mdi mdi-file-percent"
              :before-change="validateStep1"
            >
              <div class="row">
                <div class="col-md-6">
                  <b-form-group label="Vencimento">
                    <b-form-input ref="vencimento" type="date" v-model="accountPayable.data_vencimento" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Documento">
                    <b-form-input ref="numeroDocumento" type="text" v-model="accountPayable.numero_documento" />
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <label for="valorPagar">Valor R$</label>
                  <input type="text" class="form-control text-right" id="valorPagar" ref="valorPagar"
                    v-model="accountPayable.valorPagar"
                    @input="formatInputFloat($event,accountPayable,'valorPagar')"
                  >
                </div>
                <div class="col-md-6">
                  <b-form-group label="Histórico">
                    <b-form-input type="text" v-model="accountPayable.descricao" />
                  </b-form-group>
                </div>
              </div>
            </tab-content>
            <tab-content icon="mdi mdi-file-tree">
              <h2>Selecionar Categoria</h2>
              <b-row cols="1">
                <div class="position-relative">
                  <form class="app-search d-none d-lg-block" @submit.prevent>
                    <div class="position-relative">
                      <input
                        name="contaDebito"
                        type="text"
                        class="form-control"
                        placeholder="Buscar por Conta Contábil"
                        @input="filterContaDebito($event.target.value)"
                        ref="conta_debito_id"
                      />
                      <span class="ri-search-line"></span>
                    </div>
                  </form>
                </div>
                <span v-if="errors.conta_debito_id" class="error">{{ errors.conta_debito_id }}</span>
              </b-row>
              <div class="row">
                <div class="col-12 max-h-96 overflow-y-auto">
                  <!-- loop array contas -->
                  <b-row cols="1" v-for="conta in contas" :key="conta.id" class="cursor-pointer">
                    <b-col @click="setConta(conta)">
                      <b-card class="flex" :class="(accountPayable.conta_debito_id === conta.id) ? 'bg-light' : 'bg-default'">
                        <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                          <span class="text-lg font-semibold">{{ conta.descricao.substring(0, 1) }}</span>
                        </b-badge>
                        <span class="flex items-center ml-3">
                          {{ conta.descricao }}
                        </span>
                      </b-card>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </tab-content>
            <tab-content icon="mdi mdi-bank-transfer">
              <h2>Selecionar Pagamento</h2>
              <b-row cols="1">
                <div class="position-relative">
                  <form class="app-search d-none d-lg-block" @submit.prevent>
                    <div class="position-relative">
                      <input
                        name="contaCredito"
                        type="text"
                        class="form-control"
                        placeholder="Buscar por Conta Pagamento"
                        @input="filterContaCredito($event.target.value)"
                        ref="conta_credito_id"
                      />
                      <span class="ri-search-line"></span>
                    </div>
                  </form>
                </div>
                <span v-if="errors.conta_credito_id" class="error">{{ errors.conta_credito_id }}</span>
              </b-row>
              <div class="row">
                <div class="col-12 max-h-96 overflow-y-auto">
                  <b-row cols="1" v-for="pagamento in pagamentos" :key="pagamento.id" class="cursor-pointer">
                    <b-col @click="setPagamento(pagamento)">
                      <b-card class="flex" :class="(accountPayable.conta_credito_id === pagamento.id) ? 'bg-light' : 'bg-default'">
                        <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                          <span class="text-lg font-semibold">{{ pagamento.descricao.substring(0, 1) }}</span>
                        </b-badge>
                        <span class="flex items-center ml-3">
                          {{  pagamento.descricao }}
                        </span>
                      </b-card>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </b-modal>
    </layout>
</template>
